import React from 'react'

import Layout from '../components/layout'
import HomeTwo from '../components/home/HomeTwo'
import ServiceCapabilities from '../components/services/ServiceCapabilities'
import ServiceOneTeam from '../components/services/ServiceOneTeam'
import ServiceOtherSolutions from '../components/services/ServiceOtherSolutions'
import ServicePageHero from '../components/services/ServicePageHero'
import { APPLICATION_MODERNIZATION_CAPABILITIES_PT } from '../constants/serviceCapabilitiesApplicationModernization'
import { SERVICE_ONE_TEAM_APPLICATION_PT } from '../constants/serviceOneTeamContent'
import { SERVICE_OTHER_SOLUTIONS_PT } from '../constants/serviceOtherSolutionsContent'
import { SERVICE_HERO_ASSETS } from '../constants/serviceHeroAssets'

const DesenvolvimentoModernizacaoAplicacoesPagePt = props => (
  <Layout lang="pt" title="Desenvolvimento e modernização de aplicações" meta={{ description: '' }} rootProps={{ className: 'page services service-application-modernization' }}>
    <div className="service-detail-page">
      <ServicePageHero
        sectionId="service-hero"
        label="Serviços"
        title={'Desenvolvimento e modernização\nde aplicações'}
        description={
          'Desde a sua primeira ideia até uma plataforma totalmente funcional, estamos consigo em cada etapa. Aceitamos a responsabilidade de transformar a sua visão num projeto de TI de excelência.'
        }
        heroImage={SERVICE_HERO_ASSETS.app.src}
        imageAlt="Ilustração de desenvolvimento de aplicações"
        imageWidth={SERVICE_HERO_ASSETS.app.width}
        imageHeight={SERVICE_HERO_ASSETS.app.height}
      />
      <ServiceCapabilities
        idBase="service-capabilities-app-modernization"
        sectionTitle="Capacidades que impulsionam produtos digitais."
        tabs={APPLICATION_MODERNIZATION_CAPABILITIES_PT}
        contactCtaIsEn={false}
      />
      <HomeTwo lang="pt" />
      <ServiceOneTeam
        idBase="service-one-team-app-modernization"
        {...SERVICE_ONE_TEAM_APPLICATION_PT}
      />
      <ServiceOtherSolutions
        idBase="service-other-solutions-app-modernization"
        {...SERVICE_OTHER_SOLUTIONS_PT}
      />
    </div>
  </Layout>
)

export default DesenvolvimentoModernizacaoAplicacoesPagePt
